import {
  GET_SCENARIOS_REQUEST,
  ADD_SCENARIO_REQUEST,
  GET_DATASOURCES_REQUEST,
  SET_OUTPUTS,
  SET_INPUTS,
  RESET_DATA
} from '@redux/types';

const getScenarios = (scenarios) => {
  return {
    type: GET_SCENARIOS_REQUEST,
    payload: scenarios
  };
};

const addScenario = (scenario) => {
  return {
    type: ADD_SCENARIO_REQUEST,
    scenario
  };
};

const getDatasources = (datasources) => {
  return {
    type: GET_DATASOURCES_REQUEST,
    payload: datasources
  };
};

const resetData = () => {
  return {
    type: RESET_DATA
  };
};

const setOutputs = (outputs) => {
  return {
    type: SET_OUTPUTS,
    outputs
  };
};

const setInputs = (inputs) => {
  return {
    type: SET_INPUTS,
    inputs
  };
};

export {
  getScenarios,
  addScenario,
  getDatasources,
  resetData,
  setInputs,
  setOutputs
};
